/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class Selectv1Config {

    constructor (private schemaFormProvider: any,
                 private schemaFormDecoratorsProvider: any,
                 private sfPathProvider: any) {

        let selectv1: any = function(name: any, schema: any, options: any): any {
            var f: any;
            if (schema.type === 'string' && schema.enum) {
                f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'selectv1';
                if (!f.titleMap) {
                  f.titleMap = schema['enum'].map((e) => ({name: e, value: e}))
                }
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        schemaFormProvider.defaults.string.unshift(selectv1);
        schemaFormDecoratorsProvider.addMapping(
            'bootstrapDecorator',
            'selectv1',
            'selectv1.html'
        );
    }

    public static configure(schemaFormProvider: any, schemaFormDecoratorsProvider: any, sfPathProvider: any): Selectv1Config {
        return new Selectv1Config(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider);
    }
}

Selectv1Config.configure.$inject = [
    'schemaFormProvider',
    'schemaFormDecoratorsProvider',
    'sfPathProvider'
];

class Selectv1Run {
    constructor ($templateCache: angular.ITemplateCacheService) {
        $templateCache.put('selectv1.html', `
            <div class="form-group {{form.htmlClass}} schema-form-select" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false, \'required-field\': form.required}">
                <div class="row">
                    <div class="col-sm-4">
                        <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label>
                    </div>

                    <div class="col-sm-6">
                        <select ng-if="!form.required" ng-model="$$value$$" ng-model-options="form.ngModelOptions" ng-disabled="form.readonly" sf-changed="form" class="form-control {{form.fieldHtmlClass}}" schema-validate="form" ng-options="item.value as item.name group by item.group for item in form.titleMap" name="{{form.key.slice(-1)[0]}}">
                        </select>
                        <select ng-if="form.required" required ng-model="$$value$$" ng-model-options="form.ngModelOptions" ng-disabled="form.readonly" sf-changed="form" class="form-control {{form.fieldHtmlClass}}" schema-validate="form" ng-options="item.value as item.name group by item.group for item in form.titleMap" name="{{form.key.slice(-1)[0]}}">
                        </select>
                        <span class="material-input-dropdown"/>
                        <div ng-if="form.required" class="empty-field">You can't leave this empty.</div>
                    </div>
                </div>
            </div>
        `);
    }

    public static run($templateCache: angular.ITemplateCacheService): Selectv1Run {
        return new Selectv1Run($templateCache);
    }
}

Selectv1Run.$inject = ['$templateCache'];

angular.module('schemaForm').config(Selectv1Config.configure).run(Selectv1Run.run);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/configs/select_v1.config.ts